import { useEffect, useState } from "react";
import { useMoralis } from "react-moralis";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import { reactLocalStorage } from 'reactjs-localstorage';
import { minABI } from "../../../data/minAbi";
import { LoaderSpinner } from "../../atoms";


// const providerUrl = process.env.REACT_APP_NODE_URL;
const StepOne = () => {
  const [tokenAddress, setTokenAddress] = useState('')
  const [tokenName, setTokenName] = useState('')
  const [tokenDecimal, setTokenDecimal] = useState('')
  const [tokenSymbol, setTokenSymbol] = useState('')
  const [tokenSuply, setTokenSuply] = useState('')
  const [next, setNext] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  // const provider = new Web3.providers.HttpProvider(providerUrl);
  const { Moralis } = useMoralis()
  async function infoToken() {
    setIsLoading(true)
    // const web3 = new Web3(provider);
    const web3 = await Moralis.enableWeb3();
    try {
      let tokencontract = new web3.eth.Contract(minABI, tokenAddress);
      const desimal = await tokencontract.methods.decimals().call();
      setTokenName(await tokencontract.methods.name().call())
      setTokenDecimal(await tokencontract.methods.decimals().call())
      setTokenSymbol(await tokencontract.methods.symbol().call())
      setTokenSuply(await tokencontract.methods.totalSupply().call() / 10 ** desimal)
      setNext(true)
      setIsLoading(false)
    } catch (error) {
      toast.error(error.message)
      setIsLoading(false)
      setTokenAddress('')
    }
  }
  useEffect(() => {
    reactLocalStorage.setObject('formData', {
      tokenAddress,
      tokenName,
      decimal:tokenDecimal,
      symbol:tokenSymbol,
      supply:tokenSuply
    })
  }, [tokenAddress,
    tokenName,
    tokenDecimal,
    tokenSymbol,
    tokenSuply])
  return (
    <>
      <div className="step-info">
        <h3 className="step-title">Verify Token</h3>
        <span className="desc">Enter the token address and verify token</span>
      </div>
      <div className="form-step">
        <div className="input-wrapper">
          <span className="isRequired">*</span>
          <input value={tokenAddress} onChange={(e) => setTokenAddress(e.target.value)} type="text" className="input-token" placeholder="Token Address" />
          <div className="action">
            <button onClick={infoToken} className="link-action">Search Token</button>
          </div>
        </div>
      </div>
      <div className="tokenInfo">
        {
          next && <><div className="item d-flex">
            <span className="name">Token Name</span>
            <div className="eq">:</div>
            <span className="val">{tokenName}</span>
          </div>
            <div className="item d-flex">
              <span className="name">Decimal</span>
              <div className="eq">:</div>
              <span className="val">{tokenDecimal}</span>
            </div>
            <div className="item d-flex">
              <span className="name">Symbol</span>
              <div className="eq">:</div>
              <span className="val">{tokenSymbol}</span>
            </div>
            <div className="item d-flex">
              <span className="name">Supply</span>
              <div className="eq">:</div>
              <span className="val">{tokenSuply}</span>
            </div></>
        }
      </div>
      <div className="action-next">
        {
          next && <Link className="next-link" to="/create?step=2">NEXT</Link>
        }
      </div>
      <ToastContainer position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover />
        {
          isLoading && <LoaderSpinner />
        }
    </>
  )
}

export default StepOne
